module.exports = __webpack_public_path__ + "img/img_left_nav_bank_hover.4f0cfe1a.svg";